import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import DateSimple from "@/core/types/DateSimple";

class CurrenciesDAO {

	/**
	 * Получает список валют с сервера
	 */
	static async getList(countryCode: string, localCurrencyCode: string): Promise<RpcResponse> {
		return await RpcService.makeRequest('currencies.getList', {
			countryCode,
			localCurrencyCode,
		});
	}

	/**
	 * Получает курс одной валюты
	 */
	static async getSingleRate(
		currencyCodeFrom: string,
		currencyCodeTo: string,
		date: Date | string,
		countryCode: string
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('currencies.getRate', {
			currencyCodeFrom,
			currencyCodeTo,
			date,
			countryCode,
		});
	}

	/**
   * Получает курсы для набора пар «валюта + дата» одним запросом.
   * countryCode не передаётся: бек берёт страну из сессии.
   *
   * @param currencyCodeTo - Код целевой валюты
   * @param rates - Пары «валюта + дата»
   */
  static async getRates(
    currencyCodeTo: string,
    rates: { currencyCodeFrom: string, date: DateSimple }[]
  ): Promise<RpcResponse> {
    return await RpcService.makeRequest('currencies.getRates', {
      currencyCodeTo,
      rates,
    });
  }
}

export default CurrenciesDAO;
